if (!window.CusaGuardiansQuickAdd) {
	class CusaGuardiansQuickAdd extends HTMLElement {
		constructor() {
			super();

			this.variantId = this.dataset.variantId;
			this.variantTitle = this.dataset.variantTitle;
			this.sellingPlanId = this.dataset.sellingPlanId;
			this.checkbox = this.querySelector('#guardians-quick-add-checkbox');
		}

		connectedCallback() {
			console.group('Guardians Quick-Add Widget');
			console.log('>>> this.variantId = ', this.variantId);
			console.log('>>> this.variantTitle = ', this.variantTitle);
			console.log('>>> this.sellingPlanId = ', this.sellingPlanId);
			console.groupEnd();

			subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
				console.log(e);
				if (this.checkbox?.checked && e.complete) {
					requestAnimationFrame(() => {
						this.checkbox.checked = false;
						this.classList.add('hidden');
					});
				}
			});

			if (this.checkbox) {
				this.productForm = document.querySelector('product-form')?.querySelector('form');
				if (!this.productForm) return;

				this.inputConfigs = [
					['items[1][id]', this.variantId],
					['items[1][quantity]', '1'],
					['items[1][selling_plan]', this.sellingPlanId],
					[
						'items[1][properties][_Guardians-quick-add]',
						document.querySelector('[data-guardians-quick-add-widget-page-content-handle]')?.dataset
							.guardiansQuickAddWidgetPageContentHandle || ''
					],
					[
						'items[1][properties][_product-template]',
						document.querySelector('[data-guardians-quick-add-widget-page-content-handle]')?.dataset.productTemplate ||
							''
					]
				];

				this.productForm.addEventListener('submit', () => {
					this.removeHiddenInputs();
					if (this.checkbox.checked) {
						this.createHiddenInputs();
					}
				});

				this.checkbox.addEventListener('change', () => {
					if (!this.checkbox.checked) {
						this.removeHiddenInputs();
					}
				});
			}
		}

		disconnectedCallback() {}

		createHiddenInputs() {
			this.inputConfigs.forEach(([name, value]) => {
				const input = document.createElement('input');
				input.type = 'hidden';
				input.name = name;
				input.value = value;
				this.productForm.appendChild(input);
			});
		}

		removeHiddenInputs() {
			this.inputConfigs.forEach(([name]) => {
				const input = this.productForm.querySelector(`input[name="${name}"]`);
				if (input) input.remove();
			});
		}
	}

	// Expose to global scope to prevent HMR double-declaration issues
	window.CusaGuardiansQuickAdd = CusaGuardiansQuickAdd;

	// Prevent "already defined" error during local dev with Shopify CLI hot reload.
	if (!customElements.get('cusa-guardians-quick-add')) {
		customElements.define('cusa-guardians-quick-add', CusaGuardiansQuickAdd);
	}
}
